if (!customElements.get('region-switcher')) {
  customElements.define('region-switcher', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-region-switcher-open]');
        if (trigger) {
          event.preventDefault();
          this.open(trigger);
        }
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-region-switcher-close]')) this.close();
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right ||
              event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
        }
      }, options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.restore();
      }, options);

      // Prefer the longest matching path, so /de/ wins over the root store.
      let currentLink;
      let matchLength = -1;
      this.querySelectorAll('.region-switcher-country[href]').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        const path = url.pathname.replace(/\/$/, '');
        const matchesPath = !path || location.pathname === path || location.pathname.startsWith(path + '/');
        if (url.host === location.host && matchesPath && path.length > matchLength) {
          currentLink = link;
          matchLength = path.length;
        }
      });
      if (currentLink) currentLink.setAttribute('aria-current', 'true');

      // Reconnect cleanly when the Shopify editor replaces this section.
      ['shopify:section:select', 'shopify:block:select'].forEach((name) => {
        document.addEventListener(name, (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          this.open();
          if (name === 'shopify:block:select') event.target.scrollIntoView({ block: 'nearest' });
        }, options);
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close();
      }, options);
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.dialog.close();
      this.restore();
    }

    restore() {
      if (this.previousOverflow === undefined) return;
      document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.restore();
      this.controller.abort();
    }
  });
}
